import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        await refreshUser();
        // Clear the hash and route based on role
        window.history.replaceState({}, "", window.location.pathname);
        if (data.user?.role === "admin") {
          navigate("/admin", { replace: true, state: { user: data.user } });
        } else {
          navigate("/my-account", { replace: true, state: { user: data.user } });
        }
      } catch {
        navigate("/admin/login?error=oauth", { replace: true });
      }
    })();
  }, [location.hash, navigate, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--tmg-ivory)]">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[var(--tmg-gold)] border-t-transparent rounded-full animate-spin mx-auto mb-6" />
        <p className="tmg-overline">— Signing you in…</p>
      </div>
    </div>
  );
}
